﻿import * as $helpers from './_helpers'
import * as $modal from './_modal'
import { saveDontShowAgain, saveInteresting } from './blog.shared'
import { reloadList } from './blog.list'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    pageId: number
    postId: number
}

var options: IInitOptions

export const init = ($options: IInitOptions): void => {
    options = $options

    $helpers.partialPageInit($('.' + options.pageName))

    elem('__btn--ofinterest').click(() => {
        saveInteresting(options.postId, () => {
            reloadList()
        })
    })

    elem('__btn--close').click(() => {
        $modal.hide()
    })
}

const elem = (sel: string): JQuery => {
    return $(`.${options.pageName} .${options.pagePrefix}${sel}`)
}
